import { useContext } from 'react';
import { YearsContext } from '../context/YearsContext';

export function useYears() {
  return useContext(YearsContext);
}
